import { TruncatePrice } from "Util/NumberUtils";
import { Button, Colors, Display, Sizes } from "Views/Components/Button/Button";
import { CreditReportProductDetail } from "Views/Components/CreditReportSettings/CreditReportProductList"

type Props = {
	creditReportProducts: CreditReportProductDetail[];
	removeProduct: (product: CreditReportProductDetail) => void;
	moveBack: () => void;
}

export const SelectedProductSegment: React.FunctionComponent<Props> = ({
	creditReportProducts,
	removeProduct,
	moveBack
}) => {
	return (
		<section className="review-segment">
			<header>
				<h4>Selected product(s)</h4>
			</header>
			{creditReportProducts.map((product, index) => (
				<div key={product.id}>
					<p>
						<span><strong>Report name: </strong>{product.name}</span>
						<span>
							<Button
								display={Display.Text}
								sizes={Sizes.Small}
								colors={Colors.Error}
								onClick={() => removeProduct(product)}
							>
								Remove
							</Button>
						</span>
					</p>
					<p><span><strong>Report type: </strong>{product.type}</span></p>
					{product.previewLink && (
						<p>
							<span>
								<strong>Preview: </strong>
								<a href={product.previewLink} target="_blank" rel="noreferrer">preview</a>
							</span>
						</p>
					)}
					<p>
						<span>
							<strong>Cost: </strong>
							{product.discount > 0 && (
								<>
									<span style={{textDecoration: "line-through"}}>
										${TruncatePrice(product.originalPrice)}
									</span>
									&nbsp;&nbsp;
									<span>${TruncatePrice(product.price)}</span>
									<span>&nbsp;&nbsp;</span>
									<span style={{color: "white", background: "#DF1A6D", padding: "5px"}}>
										{product.discount}% off
									</span>
								</>
							)}
							{product.discount === 0 && (
								<span>${TruncatePrice(product.price)}</span>
							)}
						</span>
					</p>
				</div>
			))}
			
		</section>
	)
}